import React, { createContext, useContext, useState, useEffect } from 'react';

const CookieContext = createContext();

export const useCookies = () => {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error('useCookies must be used within a CookieProvider');
  }
  return context;
};

export const CookieProvider = ({ children }) => {
  const [cookiePreferences, setCookiePreferences] = useState({
    necessary: true, // Gerekli çerezler her zaman aktif
    analytics: false,
    marketing: false,
    preferences: false
  });

  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [cookieSettingsOpen, setCookieSettingsOpen] = useState(false);

  useEffect(() => {
    // Sayfa yüklendiğinde çerez tercihlerini kontrol et
    const savedPreferences = localStorage.getItem('cookiePreferences');
    const hasAcceptedCookies = localStorage.getItem('cookiesAccepted');
    
    if (savedPreferences) {
      setCookiePreferences(JSON.parse(savedPreferences));
    }
    
    if (!hasAcceptedCookies) {
      setShowCookieBanner(true);
    }
  }, []);

  const acceptAllCookies = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    };
    
    setCookiePreferences(allAccepted);
    localStorage.setItem('cookiePreferences', JSON.stringify(allAccepted));
    localStorage.setItem('cookiesAccepted', 'true');
    setShowCookieBanner(false);
  };

  const rejectAllCookies = () => {
    const onlyNecessary = {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    };
    
    setCookiePreferences(onlyNecessary);
    localStorage.setItem('cookiePreferences', JSON.stringify(onlyNecessary));
    localStorage.setItem('cookiesAccepted', 'true');
    setShowCookieBanner(false);
  };

  const updateCookiePreferences = (newPreferences) => {
    setCookiePreferences(newPreferences);
    localStorage.setItem('cookiePreferences', JSON.stringify(newPreferences));
    localStorage.setItem('cookiesAccepted', 'true');
  };

  const openCookieSettings = () => {
    setCookieSettingsOpen(true);
    setShowCookieBanner(false);
  };

  const closeCookieSettings = () => {
    setCookieSettingsOpen(false);
  };

  const value = {
    cookiePreferences,
    showCookieBanner,
    cookieSettingsOpen,
    acceptAllCookies,
    rejectAllCookies,
    updateCookiePreferences,
    openCookieSettings,
    closeCookieSettings
  };

  return (
    <CookieContext.Provider value={value}>
      {children}
    </CookieContext.Provider>
  );
};
